import React from 'react';
import { useParams } from 'react-router-dom';

import ContentWrapper from 'components/ContentWrapper/ContentWrapper';
import Panel from 'components/Panel/Panel';
import useGetEmailSettings from 'hooks/useGetAssessmentEmailSettings';
import { t } from 'locales/i18n';
import Reminders from 'pages/SettingsEmail/Reminders';

const SettingsEmail = () => {
  const { interviewUid = '' } = useParams();
  const { data, isLoading } = useGetEmailSettings(interviewUid);

  return (
    <ContentWrapper title={t('Email Settings')}>
      <Panel
        panelClassName="mt-6 p-6 gap-y-10 flex flex-col"
        isLoading={isLoading}
      >
        <Reminders interviewUid={interviewUid} data={data} />
      </Panel>
    </ContentWrapper>
  );
};

export default SettingsEmail;
